import { ComponentProps, FunctionComponent } from "react";
import { AwsIcon } from "~/assets/icons";

const {
  VITE_COMPUTE_ACCOUNT_ID,
  VITE_COMPUTE_ACCOUNT_PROVIDER,
  VITE_COMPUTE_ACCOUNT_REGION,
  VITE_COMPUTE_ACCOUNT_OWNER,
} = import.meta.env;

enum Provider {
  AWS = "AWS",
  // GCP = "GCP",
  // AZURE = "Azure",
}

interface ExternalProviderInfo {
  id: string;
  provider: Provider;
  icon: FunctionComponent<ComponentProps<"svg">>;
  region: string;
  owner: string;
}

const PROVIDER_ICONS: Record<Provider, FunctionComponent<ComponentProps<"svg">>> = {
  AWS: AwsIcon,
};

const useExternalComputeProvider = (): ExternalProviderInfo | null => {
  if (
    VITE_COMPUTE_ACCOUNT_ID &&
    VITE_COMPUTE_ACCOUNT_PROVIDER &&
    VITE_COMPUTE_ACCOUNT_REGION &&
    VITE_COMPUTE_ACCOUNT_OWNER
  ) {
    return {
      id: VITE_COMPUTE_ACCOUNT_ID,
      icon: PROVIDER_ICONS[VITE_COMPUTE_ACCOUNT_PROVIDER as Provider],
      provider: VITE_COMPUTE_ACCOUNT_PROVIDER,
      region: VITE_COMPUTE_ACCOUNT_REGION,
      owner: VITE_COMPUTE_ACCOUNT_OWNER,
    };
  }

  return null;
};

export default useExternalComputeProvider;
